export const AUTH_API = (baseURL) => {
  return {
    signInEndpoint: `${baseURL}/v1/clients/web/login`,
    signUpEndpoint: `${baseURL}/register`,
    forgotPasswordEndpoint: `${baseURL}/forgot-password`,
    resetPasswordEndpoint: `${baseURL}/reset-password`,
    profileEndpoint: `${baseURL}/v1/profile`
  }
}
